export enum SoftDeletableTopology {
  DELETED_AT = "deletedAt",
}

export enum ObjectTopology {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  ID = "objectId",
}
